import app from 'flarum/forum/app';
import addTranslateButton from './addTranslateButton';
import modifyModalTitle from './modifyModalTitle';
import modifyComposerTitle from './modifyComposerTitle';
import addEmojiPicker from './addEmojiPicker';

app.initializers.add('tf-translate-forum', () => {
  // 添加翻译按钮到TextEditor
  addTranslateButton();
  
  // 添加 emoji 选择器到 TextEditor
  // addEmojiPicker();
  
  // 修改 Modal 标题文案
  modifyModalTitle();
  
  // 修改 ComposerBody-header 的 item-title 文案
  modifyComposerTitle();
});